import i18next from "i18next";
import {leagueComparisonData} from "./leagueComparisonData";
export function leagueComparisonRows(data) {
  return leagueComparisonData(data).map(row => ({...row, label: row.key === "actual" ? i18next.t("help.leagueSeasonComparison.actual") : row.key === "expected" ? i18next.t("help.leagueSeasonComparison.expected") : row.key === "should" ? "Should" : "Market"}));
}
